export const runIfExist = (func: Function, parameter: any = null) => {
  if (typeof func === "function") {
    func(parameter)
  }
}